import { render, staticRenderFns } from "./QRCode.vue?vue&type=template&id=15ccd8d3&scoped=true&"
import script from "./QRCode.vue?vue&type=script&lang=js&"
export * from "./QRCode.vue?vue&type=script&lang=js&"
import style0 from "./QRCode.vue?vue&type=style&index=0&id=15ccd8d3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ccd8d3",
  null
  
)

export default component.exports